import SidebarMenu from '../components/menu/SidebarMenu.vue'

export default function install (Vue) {
  Vue.component('sidebar-menu', SidebarMenu)
}

export { SidebarMenu }



// WEBPACK FOOTER //
// ./src/plugins/sidebar-menu.js